import React, { useState } from 'react';
import './ConditionsTreatment.css';
import sectionImg from '../../images/Treatments/section-3.jpg';

const ConditionsTreatment = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const accordionData = [
        {
            title: "Orthopedic & Performance Medicine",
            conditions: [
                "Knee, hip, and shoulder arthritis",
                "Neck and back pain",
                "Sports injuries and recovery",
                "Chronic joint pain and stiffness",
                "Degenerative disc disease",
                "Tendon and ligament injuries",
                "Athletic performance optimization",
                "Chronic headaches and migraines"
            ],
            benefits: [
                "Reduced inflammation and pain",
                "Improved joint mobility and function",
                "Faster injury recovery times",
                "Enhanced athletic performance",
                "Delayed need for surgery"
            ],
            approach: "We utilize image-guided precision delivery of Wharton's Jelly MSCs and advanced PRP protocols to target damaged tissue directly. Our comprehensive approach combines cellular regeneration with performance optimization protocols designed for active individuals seeking to maintain peak physical function."
        },
        {
            title: "Neurological Recovery and Support",
            conditions: [
                "Post-stroke, Traumatic Brain Injury",
                "Chronic back and neck pain",
                "Peripheral neuropathy",
                "Post-stroke recovery support",
                "Neurodegenerative conditions",
                "Cognitive decline and memory issues",
                "Chronic neurological pain syndromes"
            ],
            benefits: [
                "Significant pain reduction",
                "Improved nerve function and sensation",
                "Enhanced cognitive function",
                "Better sleep and quality of life",
                "Reduced medication dependence"
            ],
            approach: "Our neurological protocols combine targeted cellular delivery with systemic IV treatments to support neural regeneration and cognitive enhancement. We utilize advanced stem cell therapies specifically designed to cross the blood-brain barrier and promote neuroplasticity."
        },
        {
            title: "Wellness & Regenerative Enhancement",
            conditions: [
                "Male and female sexual dysfunction",
                "Erectile dysfunction and low libido",
                "Hormonal imbalances",
                "Age-related performance decline",
                "Metabolic optimization needs",
                "Overall vitality enhancement"
            ],
            benefits: [
                "Enhanced sexual performance and satisfaction",
                "Improved energy and vitality",
                "Balanced hormone levels",
                "Better metabolic function",
                "Increased confidence and well-being"
            ],
            approach: "We offer comprehensive wellness protocols including regenerative intimate health treatments, performance enhancement therapies, and anti-aging cellular regeneration. Our confidential approach combines cutting-edge treatments with personalized optimization strategies."
        },
        {
            title: "Specialized Therapies & Developmental Support",
            conditions: [
                "Autism spectrum disorder support",
                "Developmental delays and challenges",
                "Complex neurological conditions",
                "Multi-system regenerative needs",
                "Advanced cellular therapy candidates",
                "Comprehensive regenerative protocols"
            ],
            benefits: [
                "Enhanced neurological development",
                "Improved behavioral outcomes",
                "Better cognitive function",
                "Comprehensive tissue regeneration",
                "Multi-system therapeutic support"
            ],
            approach: "Our specialized protocols utilize MUSE cell therapy and advanced regenerative techniques for complex cases requiring comprehensive cellular support. We develop personalized treatment plans for unique conditions that benefit from multi-modal regenerative approaches."
        }
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? -1 : index);
    };

    return (
        <section className="conditions-treatment-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <h2>Conditions We Treat & Expected Results</h2>
                            <p style={{fontSize: '18px', lineHeight: '1.8', color: '#666', maxWidth: '800px', margin: '0 auto'}}>
                                Explore specific conditions, treatment approaches, and the results you can expect from our advanced regenerative protocols.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-lg-12">
                        <div className="conditions-image">
                            <img src={sectionImg} alt="Advanced Treatment Protocols" />
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-lg-12">
                        <div className="accordion-container">
                            {accordionData.map((item, index) => (
                                <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
                                    <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                                        <h3>{item.title}</h3>
                                        <span className="accordion-icon">
                                            <i className={`fas fa-${activeIndex === index ? 'minus' : 'plus'}`}></i>
                                        </span>
                                    </div>
                                    <div className="accordion-content">
                                        <div className="content-grid">
                                            <div className="content-section">
                                                <h4>Conditions We Treat</h4>
                                                <ul className="conditions-list">
                                                    {item.conditions.map((condition, idx) => (
                                                        <li key={idx}>{condition}</li>
                                                    ))}
                                                </ul>
                                            </div>

                                            <div className="content-section">
                                                <h4>Expected Benefits</h4>
                                                <ul className="benefits-list">
                                                    {item.benefits.map((benefit, idx) => (
                                                        <li key={idx}>{benefit}</li>
                                                    ))}
                                                </ul>
                                            </div>

                                            <div className="content-section">
                                                <h4>Our Treatment Approach</h4>
                                                <p>{item.approach}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConditionsTreatment;